import { reactive, toRefs } from "vue";
import axios from 'axios';

const getOptions = (resource) => {

    const initialState = reactive({
        data: [],
       
        pending: true,
        error: {
            statusCode: null,
            name: null,
            message: null
        }
    });
    
    const state = reactive({ ...initialState });

    const resetState = () => {
        Object.assign(state, initialState);
    }

    const load = async (params = null) => {
        // resetState();
        state.pending = true;
        try {
            const response = await axios.get(`/${resource}`, { params });

            state.data = response.data;
    
            
            return response.data;
        } catch (error) {
            state.error.statusCode = error.response.status;
            state.error.name = error.message;
            state.error.message = error.response.data.message;
        } finally {
            state.pending = false;
        }
    }

    return { ...toRefs(state), load }
}

export default getOptions